<template>
  <div>
    <div class="phone-selector-container-mobile">
      <div class="col" style="margin-bottom: 2rem;" v-if="$whitelabel.showLogo()">
        <img :src="require('../../../assets/sqrql_logo.png')" width="160px" height="160px">
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem; min-height: 222px;" v-if="processing">
        <b-spinner variant="teal" label="Spinning"></b-spinner>
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem;" v-else>
        <div class="col-12" style="min-height: 60px;">
          <b-alert variant="danger" :show="isAlert">{{ alert }}</b-alert>
        </div>
        <form method="post" @submit.prevent="reset" name="reset" v-if="!invalid">
          <div class="col-12">
            <div class="col-12">
              <b-form-input
                id="password"
                v-model="password"
                type="password"
                required
                placeholder="Password"
              ></b-form-input>
            </div>
          </div>
          <div class="col-12" style="margin-top: 1rem;">
            <div class="col-12">
              <b-form-input
                id="repassword"
                v-model="repassword"
                type="password"
                required
                placeholder="Re-Password"
              ></b-form-input>
            </div>
          </div>
          <div class="col-10 offset-1" style="margin-top: 2rem;">
            <b-button variant="primary" type="submit" block style="background-color: #009AB1; border-color: #009AB1;">Reset Password</b-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'reset-password',
    mounted () {
      this.tokenChecker()
    },
    data () {
      return {
        password: '',
        repassword: '',
        alert: 'This link is not valid.',
        isAlert: false,
        processing: false,
        invalid: false
      }
    },
    methods: {
      tokenChecker: async function () {
        var self = this
        self.isAlert = false
        self.processing = true
        try {
          await axios.get(`${process.env.MYR_ROOT}/password_resets/${self.$route.params.token}`)
          self.processing = false
        } catch (error) {
          self.alert = 'This link is not valid.'
          self.isAlert = true
          self.processing = false
          self.invalid = true
        }
      },
      reset: async function () {
        var self = this
        self.isAlert = false
        self.processing = true
        try {
          if (!self.validatePassword(self.password)) {
            self.isAlert = true
            self.alert = 'Please enter valid password. Password should be at least 8 characters long and should contain a uppercase character, a lowercase character and a number.'
          } else if (self.password !== self.repassword) {
            self.isAlert = true
            self.alert = 'Re-Password should match Password.'
          } else {
            await axios.patch(`${process.env.MYR_ROOT}/password_resets/${self.$route.params.token}`, { password: self.password, password_confirmation: self.repassword })
            this.$router.push({ name: 'Login' })
          }
          self.processing = false
        } catch (error) {
          console.log(error)
          self.alert = 'Oops! Something went wrong.'
          self.isAlert = true
          self.processing = false
        }
      },
      validatePassword (password) {
        // Validate lowercase letters
        var lowerCaseLetters = /[a-z]/g
        if (!password.match(lowerCaseLetters)) {
          return false
        }

        // Validate capital letters
        var upperCaseLetters = /[A-Z]/g
        if (!password.match(upperCaseLetters)) {
          return false
        }

        // Validate numbers
        var numbers = /[0-9]/g
        if (!password.match(numbers)) {
          return false
        }

        // Validate length
        if (password.length < 8) {
          return false
        }
        return true
      }
    }
  }
</script>

<style scopped>
.phone-selector-container-mobile {
  background-color: white;
  padding: 20px !important;
  margin: 0 auto 0 auto !important;
  overflow: hidden;
  text-align: center !important;
}
.text-teal {
  color: #009AB1;
}
</style>
